import { render, staticRenderFns } from "./ListOrders.vue?vue&type=template&id=2f88ccfe"
import script from "./ListOrders.vue?vue&type=script&lang=js"
export * from "./ListOrders.vue?vue&type=script&lang=js"
import style0 from "./ListOrders.vue?vue&type=style&index=0&id=2f88ccfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports